import * as type from '../actions/types';

const initialState = {
  data: null,
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_EVENT_PENDING: {
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.FETCH_EVENT_SUCCESS: {
      return {
        ...state,
        data: action.payload.data?.event,
        pending: false,
        success: true,
      };
    }

    case type.FETCH_EVENT_FAILURE: {
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
